/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Address_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Street address" |
*
* @param {Tfield_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_address_placeholder = /** @type {((inputs?: Tfield_Address_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Address_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse postale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección postal")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Endereço completo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo")
	return /** @type {LocalizedString} */ ("Street address")
});